<template funtional>
  <div ref="root" class="sideBar" :class="{ 'sideBar-show': showSideBar }">
    <a
      href="javascript:void(0);"
      class="icon-btn"
      @mouseenter="showInfoBlock1 = true"
      @mouseleave="showInfoBlock1 = false"
      style="cursor: default"
    >
      <div class="icon icon-mobile"></div>
      手机版
    </a>
    <div class="infoBlock" v-show="showInfoBlock1">
      <img
        src="../assets/img/app_qrcode.png"
        alt="手机版网站"
        style="width: 110px; height: 110px"
      />
      <p>一键扫描，手机下载</p>
    </div>
    <a
      href="javascript:void(0);"
      class="icon-btn"
      @mouseenter="showInfoBlock2 = true"
      @mouseleave="showInfoBlock2 = false"
      style="cursor: default"
    >
      <div class="icon icon-wechat"></div>
      telegram
    </a>
    <div class="infoBlock" v-show="showInfoBlock2" style="top: 90px">
      <!-- <img
        src="../assets/img/wxQrcode.png"
        alt="微信客服"
        style="width: 110px; height: 110px"
      />
      <p>扫一扫，加微信</p> -->
      <p>
        <span>TG：@vip766949</span><br />
        <span>TG频道： t.me/csj766949</span><br />
        <span>TG群： https://t.me/+klFwvJkcIlZkMDdl</span>
      </p>
      <p>添加Telegram好友</p>
    </div>
    <a
      href="javascript:void(0);"
      class="icon-btn"
      @mouseenter="showInfoBlock3 = true"
      @mouseleave="showInfoBlock3 = false"
      style="cursor: default"
    >
      <div class="icon icon-qq"></div>
      skype
    </a>
    <div class="infoBlock" v-show="showInfoBlock3" style="top: 150px">
      <!-- <img
        src="../assets/img/qqQrcode.png"
        alt="QQ客服"
        style="width: 110px; height: 120px"
      />
      <p>扫一扫，加我QQ</p> -->
      <p>live:.cid.5aa5ac8ded152a08</p>
      <p>添加Skype好友</p>
    </div>
    <a @click="openJiaxinTogglerDiv" class="icon-btn">
      <div class="icon icon-online-chat"></div>
      在线客服
    </a>
    <a @click="gotoTop" class="icon-btn">
      <div class="icon icon-top"></div>
      顶部
    </a>
  </div>
</template>
<script>
import { setTimeout } from "timers";
import _ from "lodash";
export default {
  data() {
    return {
      showSideBar: false,
      showInfoBlock1: false,
      showInfoBlock2: false,
      showInfoBlock3: false,
    };
  },
  mounted() {
    var _this = this;
    setTimeout(function () {
      _this.showSideBar = true;
    }, 300);
    const sideBar = this.$refs.root;
    const adjustBottomOfSideBar = () => {
      sideBar.style.position = "fixed";
      sideBar.style.top = window.innerHeight / 2 - 300 / 2 + "px"; // middle of screen
    };
    window.addEventListener("resize", _.debounce(adjustBottomOfSideBar, 50));
    adjustBottomOfSideBar();
  },
  methods: {
    openJiaxinTogglerDiv() {
      window.jiaxinTogglerDiv();
    },
    gotoTop() {
      window.scrollTo({
        left: 0,
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
<style lang="scss">
.sideBar {
  opacity: 0;
  position: fixed;
  right: 25px;
  top: 50%;
  z-index: 2;
  //   margin-right: -715px;
  transition: all 0.5s;

  &-show {
    opacity: 1;
  }

  .infoBlock {
    width: 119px;
    height: auto;
    padding: 10px;
    border: 1px solid #e9e9e9;
    border-right: 1px solid #ededed;
    background: #ffffff;
    position: absolute;
    top: 30px;
    left: -145px;
    text-align: center;
    font-size: 0.8rem;
    color: #666666;
    box-shadow: 0 5px 5px #ccc;

    p {
      margin: 10px 0;
      word-break: break-all; //内容超出自动换行
    }
  }

  .icon-btn {
    cursor: pointer;
    display: block;
    width: 50px;
    height: 55px;
    margin-bottom: 5px;
    color: #ef2f22;
    text-align: center;
    font-size: 0.7em;
    background-color: white;
    box-shadow: 1px 1px 2px #ccc;
    .icon {
      width: 50px;
      height: 36px;

      &-mobile {
        background: url("../assets/img/pc/sideBar/icon_mobile_r.png") 41% 55%
          no-repeat;
      }

      &-wechat {
        background: url("../assets/img/pc/sideBar/icon_wechat_r.png") 41% 55%
          no-repeat;
      }

      &-qq {
        background: url("../assets/img/pc/sideBar/icon_qq_r.png") 41% 55%
          no-repeat;
      }

      &-online-chat {
        background: url("../assets/img/pc/sideBar/icon_online_chat_r.png") 41%
          55% no-repeat;
      }

      &-top {
        background: url("../assets/img/pc/sideBar/icon_top_r.png") 41% 55%
          no-repeat;
      }
    }

    &:hover {
      background-color: #ef2f22;
      color: white;

      .icon {
        &-mobile {
          background: url("../assets/img/pc/sideBar/icon_mobile_w.png") 41% 55%
            no-repeat;
        }

        &-wechat {
          background: url("../assets/img/pc/sideBar/icon_wechat_w.png") 41% 55%
            no-repeat;
        }

        &-qq {
          background: url("../assets/img/pc/sideBar/icon_qq_w.png") 41% 55%
            no-repeat;
        }

        &-online-chat {
          background: url("../assets/img/pc/sideBar/icon_online_chat_w.png") 41%
            55% no-repeat;
        }

        &-top {
          background: url("../assets/img/pc/sideBar/icon_top_w.png") 41% 55%
            no-repeat;
        }
      }
    }
  }
}
</style>

